module.exports = __webpack_public_path__ + "img/sum-grey.161d83f8.svg";